export function renderTipTapJsonToHtml(json: any): string {
  if (!json || !json.content) return '';

  const renderContent = (nodes: any[]): string => {
    return nodes
      .map((node) => {
        if (node.type === 'paragraph') {
          return `<p>${renderText(node.content)}</p>`;
        }
        if (node.type === 'bulletList') {
          return `<ul>${renderListItems(node.content)}</ul>`;
        }
        if (node.type === 'orderedList') {
          return `<ol>${renderListItems(node.content)}</ol>`;
        }
        if (node.type === 'listItem') {
          return `<li>${renderText(node.content)}</li>`;
        }
        return '';
      })
      .join('');
  };

  const renderText = (items: any[] = []): string => {
    return items
      .map((item) => {
        if (item.type === 'text') {
          if (item.marks?.some((mark: any) => mark.type === 'link')) {
            const link = item.marks.find((m: any) => m.type === 'link');
            return `<a href="${link.attrs.href}" target="_blank">${item.text}</a>`;
          }
          return item.text;
        }
        return '';
      })
      .join('');
  };

  const renderListItems = (items: any[]): string =>
    items.map((item) => renderContent([item])).join('');

  return renderContent(json.content);
}
